import { useRuntime } from './useRuntime';

export const useConfig = () => {
  const { apiConfig } = useRuntime();

  return {
    api: apiConfig,
  };
};
